Ext.define('SA.lq.SearchQueryFactory', {
    constructor({resultLimit, censusReleaseYear, gridColumnCfgFactory}) {
        this.resultLimit = resultLimit;
        this.censusReleaseYear = censusReleaseYear;
        this.gridColumnCfgFactory = gridColumnCfgFactory;
    },

    createQuery(state) {
        var sort = state.getSortModel(),
            conditionList = state.getConditionList(),
            attributeIds = conditionList.getUniqueAttributeIds(),
            location = state.getSelectedLocationModel(),
            geoUnit = state.getSelectedGeoUnit(),
            geoUnitId = state.getSelectedGeoUnitId(),
            columnCfgs = this.gridColumnCfgFactory.getCfgs({sort, attributeIds}),
            query = SA.data.Query.from({
                type: 'locations',
                fields: ['locationSeries', 'name', ...attributeIds],
                limit: this.resultLimit,
                filter: conditionList.toPredicateWithNotNulls().serialize(),
                sort: sort.hasAttributeId('name') ? [sort.toTuple()] : [sort.toTuple(), ['asc', 'name']],

                where: SA.Predicate.and([
                    SA.Predicate.equal('censusRelease', this.censusReleaseYear),
                    SA.Predicate.equal('geographicUnit', geoUnitId),
                    SA.Predicate.withinOrRadius({location, geoUnitId})
                ]).serialize()
            });

        query.setResponseMapper(response => this.createResult({geoUnit, query, columnCfgs, response}));
        query.addSuccess(this.successHandler);

        return query;
    },

    createResult({geoUnit, query, columnCfgs, response}) {
        return new SA.lq.SearchResult({
            geoUnit,
            columnCfgs,

            data: response.map((tuple, index) => {
                var rank = index + 1,
                    {locationSeries, name, ...attributes} = query.mapResult(tuple),
                    locationInfo = {locationSeries, name};

                return {locationInfo, rank, ...attributes};
            })
        });
    },

    setSuccessHandler(successHandler) {
        this.successHandler = successHandler;
    }
});